import { Injectable } from '@angular/core'
import { CanDeactivate } from '@angular/router'
import { Observable } from 'rxjs'

export interface UnsavedChangesConfig {
  // Eine Bedingung, bei der der Guard aktiv werden soll (z. B. neuer Datensatz: uuid == null)
  condition: () => boolean
  // Callback, der entscheiden soll, ob die Seite verlassen werden darf.
  // Muss true (verlassen) oder false (bleiben) als boolean oder Observable zurückgeben.
  confirmLeave: () => boolean | Observable<boolean>
}

@Injectable({ providedIn: 'root' })
export class UnsavedChangesGuard implements CanDeactivate<unknown> {
  private config: UnsavedChangesConfig | null = null

  public register(config: UnsavedChangesConfig): void {
    this.config = config
  }

  public unregister(): void {
    this.config = null
  }

  // Used in the beforeunload event of the Host (Browser) to determine whether to show the error dialog or not
  public hasUnsavedChanges(): boolean {
    if (this.config === null) return false
    return this.config.condition()
  }

  public canDeactivate(): boolean | Observable<boolean> {
    // Wenn nichts registriert oder Bedingung nicht erfüllt → frei navigieren
    if (this.config === null) return true
    if (!this.config.condition()) return true

    return this.config.confirmLeave()
  }
}
